<template>
  <button
    :type="type"
    :disabled="isDisabled"
    class="bordered-button"
    v-bind="$attrs"
  >
    <TheSpinner v-if="isLoading"/>
    <slot />
  </button>
</template>

<script>
import TheSpinner from '@/components/TheSpinner.vue'

export default {
  name: 'FilledButton',

  components: { TheSpinner },

  props: {
    type: {
      type: String,
      default: 'button'
    },

    isLoading: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isDisabled() {
      return this.isLoading || this.disabled
    }
  }
}
</script>

<style scoped lang="scss">
.bordered-button {
  display: inline-flex;
  padding: 13px 23px;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: border 0.3s;
  font-size: 18px;
  border-radius: 12px;
  border: 2px solid #dcdde0;
  color: #9a2b0b;

  &:hover:not(:disabled) {
    border-color: #9a2b0b;
  }

  &:disabled {
    cursor: default;
  }
}
</style>
